import Swal from 'sweetalert2';

export const handleExcelUpload = async (file, onSuccess) => {
  const confirm = await Swal.fire({
    title: 'Upload Excel?',
    text: 'This will process and update all matching employee IDs in bulk.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, Upload',
    cancelButtonText: 'Cancel',
  });

  if (!confirm.isConfirmed) return;

  const formData = new FormData();
  formData.append('file', file);

  Swal.fire({
    title: 'Uploading...',
    html: 'Please wait while we process the file.',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    const res = await fetch('https://api.stitchtechsolutions.com/api/upload_loans_excel.php', {
      method: 'POST',
      body: formData,
    });

    const text = await res.text();
    let result;
    try {
      result = JSON.parse(text);
    } catch (e) {
      console.error('Failed to parse response:', text);
      throw new Error('Server returned invalid response');
    }

    if (result.status === 'conflict') {
      // Show conflict data summary
      const count = result.conflicts.length;
      const summary = result.conflicts
        .map(r => `• ${r.employee_id} - ${r.client_name}`)
        .slice(0, 10)
        .join('<br>');

      const conflictConfirm = await Swal.fire({
        title: `${count} existing employee(s) found`,
        html: `The following already exist:<br><br>${summary}<br><br>Do you want to resume upload and update these records?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Resume Upload',
        cancelButtonText: 'Cancel',
        width: 600,
      });

      if (!conflictConfirm.isConfirmed) {
        Swal.fire('Cancelled', 'Upload aborted.', 'info');
        return;
      }

      Swal.fire({
        title: 'Resuming upload...',
        html: 'Please wait while we update the existing records.',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const resumeRes = await fetch('https://api.stitchtechsolutions.com/api/resume_upload.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: result.toUpdate })
      });

      const resumeData = await resumeRes.json();
      Swal.fire({
        title: resumeData.status === 'success' ? 'Upload Complete' : 'Resume Failed',
        html: resumeData.message,
        icon: resumeData.status === 'success' ? 'success' : 'error'
      });

      if (resumeData.status === 'success' && typeof onSuccess === 'function') {
        onSuccess();
      }

      return;
    }

    if (!res.ok) throw new Error(result.message || 'Upload failed');

    let message = result.message;
    if (result.errors && result.errors.length > 0) {
      message += `<br><br>Errors occurred in ${result.errors.length} rows.`;
    }

    Swal.fire({
      title: result.status === 'success' ? 'Upload Complete' : 'Upload Failed',
      html: message,
      icon: result.status === 'success' ? 'success' : 'error'
    });

    if (result.status === 'success' && typeof onSuccess === 'function') {
      onSuccess();
    }

  } catch (err) {
    console.error('Upload error:', err);
    Swal.fire({
      title: 'Upload Failed',
      text: err.message || 'An unexpected error occurred',
      icon: 'error'
    });
  }
};
